import client from './client';

export interface DrillRow {
  trans_id: number;
  line_id: number;
  due_date: string | null;
  account_key: string;
  account_name: string | null;
  sort_code: string | null;
  debit_credit: 1 | 2;
  amount: number;
  description: string | null;
  reference: string | null;
}

export interface DrillResponse {
  selector_label: string;
  period_label: string;
  total_signed: number;
  total_debit: number;
  total_credit: number;
  line_count: number;
  rows: DrillRow[];
}

export interface DrillSelector {
  /** Comma-separated sort_codes; ranges accepted as "300-399". */
  sort_codes?: string;
  /** Comma-separated specific account keys. */
  account_keys?: string;
  /** Master-tree node code (e.g. "1342"). The backend resolves it to
   *  every account_key + sort_group under the node's subtree. */
  tree_code?: string;
  from_date: string;
  to_date: string;
  side?: 'debit' | 'credit' | 'both';
  label?: string;
  /**
   * Optional P&L / BS category that produced this drill-down (e.g.
   * "revenue", "sga"). When present, the modal exposes a quick link to
   * the classification editor so the auditor can move sort_codes
   * between categories without leaving the report.
   */
  category?: string;
}

export async function getBreakdown(sel: DrillSelector): Promise<DrillResponse> {
  const res = await client.get<DrillResponse>('/drilldown/breakdown', { params: sel });
  return res.data;
}
